import type { IxcSweepsV1SweepPlanKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const SWEEP_PLAN_BASE_PATH = getResolvedPath('/sweep/plan');

export const getSweepPlanPath: EntityPathBuilder<IxcSweepsV1SweepPlanKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SWEEP_PLAN_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sweepPlanId) {
        return undefined;
      }

      return getResolvedPath(`${SWEEP_PLAN_BASE_PATH}/$sweepPlanId`, context.keys);
    }
  }
};

export function getSweepPlanDetailPath(sweepPlanId: string | undefined) {
  if (!sweepPlanId) {
    return undefined;
  }

  return getSweepPlanPath({ kind: 'detail', keys: { sweepPlanId } });
}

